
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/konfirmasi-unor",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/konfirmasi-unor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/konfirmasi-unor"])
      });
    }
  